function setupDashboardMotion(root = document) {
  const page = root.querySelector('.topic-v2-dashboard');
  if (!page) return () => {};

  const targets = page.querySelectorAll([
    '.topic-v2-hero-copy > *',
    '.topic-v2-hero-visual',
    '.topic-v3-narrative > section',
    '.topic-v3-focus-list li',
    '.topic-v3-dashboard-visual',
    '.topic-v3-case',
    '.topic-v3-knowledge-items article',
    '.topic-v2-faq',
    '.topic-v2-bottom-cta',
    '.topic-v2-related',
  ].join(','));
  targets.forEach(target => target.classList.add('topic-motion-reveal'));
  const showAll = () => targets.forEach(target => target.classList.add('is-visible'));
  const reduceMotion = window.matchMedia?.('(prefers-reduced-motion: reduce)').matches;

  if (!targets.length || reduceMotion || !('IntersectionObserver' in window)) {
    showAll();
    return () => {};
  }

  page.classList.add('topic-motion-ready');
  const observer = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (!entry.isIntersecting) return;
      entry.target.classList.add('is-visible');
      observer.unobserve(entry.target);
    });
  }, { threshold: 0.08, rootMargin: '0px 0px -6% 0px' });

  targets.forEach(target => observer.observe(target));
  return () => {
    observer.disconnect();
    page.classList.remove('topic-motion-ready');
  };
}

module.exports = setupDashboardMotion;
